/* eslint-disable default-case, no-param-reassign */
import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import produce from 'immer';
import LocalStorageService from 'services/local-storage-service';
import { formatEndpoint, HcsAPI } from 'services/api-repositories';
import { actions, SettingsActions } from '.';
import { SettingsState } from './types';

const localStorageState = LocalStorageService.getSettings();
const initialState = localStorageState || {
  workflowId: '4ad1a3c3-13a6-4c1d-824b-8cef02375ba3',
  endpoint: 'https://demo-hcs.azurewebsites.net/swagger/index.html',
  clientId: '888b9145-7ea5-49cc-bf5d-f4fc345819c3',
  clientSecret: '',
  outputMap: {
    pdfFileId: 'FinalPdf',
    textFileId: 'TextFile',
    mergedFileId: 'pdfFileId',
    documentType: 'DocumentType',
    pii: 'ExtractedTargets',
    idPredictions: 'IdPredictions',
    pagesDataExtraction: 'ExtractedData',
    documentDataExtraction: 'ExtractedDocumentData',
    dataExtractionV2: 'ExtractedData',
    faceVerification: 'VerificationResults',
    idCutOut: 'CutOutIds',
    riskAssessment: 'RiskAssessment',
    fileId: 'RiskAssessmentId',
    crossMatchResults: 'CrossMatchResults',
    parsedEmail: 'ParsedEmail',
  },
};

const reducer: Reducer<SettingsState, SettingsActions> = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case getType(actions.updateSettings): {
        LocalStorageService.updateSettings(action.payload);
        if (draft.endpoint !== action.payload.endpoint) {
          HcsAPI.defaults.baseURL = formatEndpoint(action.payload.endpoint);
        }
        draft = action.payload;
        break;
      }
    }

    return draft as SettingsState;
  });

export default reducer;
